import { Text } from '@mantine/core';
import type { ReactNode } from 'react';
import classes from './RiskTag.module.css';

export type RiskTagTier = 0 | 1 | 2 | 'unknown';

type Props = {
  tier: RiskTagTier;
  children: ReactNode;
  size?: string;
  'data-testid'?: string;
};

const tierColors: Record<RiskTagTier, { c: string; bgc: string }> = {
  0: { c: 'grayBrand.6', bgc: 'grayBrand.0' },
  1: { c: 'yellowBrand.9', bgc: 'yellowBrand.1' },
  2: { c: 'redBrand.9', bgc: 'redBrand.1' },
  unknown: { c: 'grayBrand.5', bgc: 'grayBrand.0' },
};

export const RiskTag = ({
  tier,
  children,
  size = 'md',
  'data-testid': testId,
}: Props) => {
  const { c, bgc } = tierColors[tier] ?? tierColors.unknown;

  return (
    <Text
      size={size}
      fw={500}
      px="xs"
      c={c}
      bg={bgc}
      className={classes.tag}
      data-tier={tier}
      data-testid={testId}
    >
      {children}
    </Text>
  );
};
